(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-blog-article-products"]) return;
  try {
    
  (function () {
    function init() {
      var section = document.querySelector('[data-blog-article-products]');
      if (!section) return;

      var articleId = section.getAttribute('data-article-id');
      var articleHandle = section.getAttribute('data-article-handle');
      var apiBase = section.getAttribute('data-api-base');
      var labelBestseller = section.getAttribute('data-label-bestseller') || 'Bestseller';
      var labelNew = section.getAttribute('data-label-new') || 'Neu';
      var labelUnique = section.getAttribute('data-label-unique') || 'Unikat';
      var mount = section.querySelector('[data-blog-article-products-mount]');
      if ((!articleId && !articleHandle) || !apiBase || !mount) return;

      var locale = document.documentElement.lang || 'de';
      var currency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

      function formatMoney(amount) {
        var value = Number(amount) || 0;
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(value);
        } catch (e) {
          return value + ' ' + currency;
        }
      }

      function withWidth(url, width) {
        if (!url) return url;
        return url.indexOf('?') !== -1 ? url + '&width=' + width : url + '?width=' + width;
      }

      function escapeHtml(str) {
        return String(str == null ? '' : str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function splitTitle(rawTitle) {
        var normalized = String(rawTitle || '')
          .replace(/ – /g, ' - ')
          .replace(/ — /g, ' - ');
        var parts = normalized.split(' - ');
        var base = parts.length > 1 ? parts.slice(0, parts.length - 1).join(' - ') : normalized;
        base = base.trim();

        var words = base.split(' ');
        var line1 = '';
        var line2 = '';
        var foundNumber = false;
        var foundCm = false;
        for (var k = 0; k < words.length; k++) {
          var word = words[k];
          if (foundCm) break;
          if (foundNumber) {
            line2 += word + ' ';
            if (word === 'cm') foundCm = true;
          } else {
            var n = parseInt(word, 10);
            if ((!isNaN(n) && n !== 0) || word === '0') {
              foundNumber = true;
              line2 += word + ' ';
            } else {
              line1 += word + ' ';
            }
          }
        }
        return { line1: line1.trim(), line2: line2.trim() };
      }

      function cardHtml(p) {
        var title = escapeHtml(p.title);
        var url = escapeHtml(p.url);
        var tags = p.tags || [];

        var onSale = p.compareAtPrice && Number(p.compareAtPrice) > Number(p.price);
        var discount = Number(p.discountPercentage) || 0;
        if (!discount && onSale) {
          discount = Math.round(
            ((Number(p.compareAtPrice) - Number(p.price)) / Number(p.compareAtPrice)) * 100
          );
        }
        var isOnSale = onSale || discount > 0;

        function hasTag(name) {
          for (var i = 0; i < tags.length; i++) {
            if (String(tags[i]).toLowerCase() === name) return true;
          }
          return false;
        }

        var badges = '';
        if (isOnSale && discount > 0) {
          badges += '<span class="product-badge bg-primary! text-white">-' + discount + '%</span>';
        }
        if (hasTag('bestseller')) {
          badges += '<span class="product-badge">' + escapeHtml(labelBestseller) + '</span>';
        }
        if (hasTag('neu')) {
          badges += '<span class="product-badge">' + escapeHtml(labelNew) + '</span>';
        }
        if (hasTag('unikat')) {
          badges += '<span class="product-badge">' + escapeHtml(labelUnique) + '</span>';
        }

        var hasHover = !!p.roomImageUrl;
        var primaryImg = p.imageUrl
          ? '<img src="' +
            escapeHtml(withWidth(p.imageUrl, 400)) +
            '" alt="' +
            title +
            '" class="aspect-4/5 h-full w-full bg-white object-contain transition-all duration-300 ease-in-out ' +
            (hasHover ? 'group-hover:opacity-0' : 'group-hover:scale-90') +
            '" loading="lazy" decoding="async" width="400" height="500">'
          : '<div class="bg-muted h-full w-full"></div>';

        // Decorative: covers the whole box, so it must not repeat the title.
        var hoverImg = hasHover
          ? '<img src="' +
            escapeHtml(withWidth(p.roomImageUrl, 600)) +
            '" alt="" aria-hidden="true" class="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100" loading="lazy" decoding="async" width="600" height="750">'
          : '';

        var t = splitTitle(p.title);
        var titleHtml =
          '<span class="font-medium">' +
          escapeHtml(t.line1) +
          '</span>' +
          (t.line2 ? '<br><span class="font-light">' + escapeHtml(t.line2) + '</span>' : '');

        var priceHtml =
          '<span class="text-base ' +
          (isOnSale ? 'text-primary font-semibold' : 'font-medium') +
          '">' +
          escapeHtml(formatMoney(p.price)) +
          '</span>';
        if (onSale) {
          priceHtml +=
            '<span class="text-foreground/70 text-sm line-through">' +
            escapeHtml(formatMoney(p.compareAtPrice)) +
            '</span>';
        }

        return (
          '<div data-carousel-item class="w-[60%] shrink-0 sm:w-[40%] md:w-[32%] lg:w-[25%]" role="listitem">' +
          '<div class="group relative flex h-full flex-col space-y-2">' +
          '<div class="absolute top-0 right-0 left-0 z-10 flex flex-wrap items-start gap-1.5">' +
          badges +
          '</div>' +
          '<a href="' +
          url +
          '" class="block" aria-label="' +
          title +
          '">' +
          '<div class="product-image relative aspect-4/5 overflow-hidden bg-white">' +
          primaryImg +
          hoverImg +
          '</div></a>' +
          '<div class="my-2 flex flex-1 flex-col justify-between space-y-0.5">' +
          '<a href="' +
          url +
          '" class="text-foreground hover:text-primary inline-block w-full text-center text-sm leading-snug text-wrap">' +
          titleHtml +
          '</a>' +
          '<div class="flex flex-wrap items-center justify-center gap-1.5">' +
          priceHtml +
          '</div></div></div></div>'
        );
      }

      var CHEVRON_LEFT =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>';
      var CHEVRON_RIGHT =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';

      function render(products) {
        var items = products.map(cardHtml).join('');
        section.classList.remove('hidden');
        mount.innerHTML =
          '<base-carousel>' +
          '<div data-carousel-wrapper class="no-scrollbar relative mt-5 flex items-stretch gap-5 overflow-x-auto" role="list">' +
          items +
          '</div>' +
          '<button data-carousel-prev type="button" class="border-border focus-visible:ring-foreground absolute top-2/5 -left-3 grid h-10 w-10 -translate-y-1/2 place-content-center rounded-full border bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50 [&>svg]:size-6" aria-label="Previous product">' +
          CHEVRON_LEFT +
          '</button>' +
          '<button data-carousel-next type="button" class="border-border focus-visible:ring-foreground absolute top-2/5 -right-3 grid h-10 w-10 -translate-y-1/2 place-content-center rounded-full border bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50 [&>svg]:size-6" aria-label="Next product">' +
          CHEVRON_RIGHT +
          '</button>' +
          '</base-carousel>';
      }

      var query =
        '/products?locale=' +
        encodeURIComponent(locale) +
        '&currency=' +
        encodeURIComponent(currency);

      var urls = [];
      if (articleId) {
        urls.push(
          apiBase + '/public/storefront/blog-articles/by-id/' + encodeURIComponent(articleId) + query
        );
      }
      if (articleHandle) {
        urls.push(
          apiBase + '/public/storefront/blog-articles/' + encodeURIComponent(articleHandle) + query
        );
      }

      function tryFetch(i) {
        if (i >= urls.length) return;
        fetch(urls[i])
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
          })
          .then(function (data) {
            var products = (data && data.products) || [];
            if (products.length) {
              render(products);
            } else {
              tryFetch(i + 1);
            }
          })
          .catch(function () {
            tryFetch(i + 1);
          });
      }

      tryFetch(0);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      if (root.dataset.heroSliderReady) return;
      root.dataset.heroSliderReady = 'true';

      var track = root.querySelector('[data-hero-track]');
      if (!track) return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
      var prev = root.querySelector('[data-hero-prev]');
      var next = root.querySelector('[data-hero-next]');
      if (slides.length < 2) return;

      var index = 0;

      function preload(i) {
        [i - 1, i, i + 1].forEach(function (n) {
          var slide = slides[n];
          if (!slide) return;
          var img = slide.querySelector('img');
          if (!img || img.loading !== 'lazy') return;
          img.fetchPriority = 'auto';
          img.loading = 'eager';
        });
      }

      function setIndex(i) {
        index = Math.max(0, Math.min(slides.length - 1, i));
        preload(index);

        dots.forEach(function (dot, d) {
          var active = d === index;
          dot.classList.toggle('w-6', active);
          dot.classList.toggle('sm:w-10', active);
          dot.classList.toggle('bg-white', active);
          dot.classList.toggle('w-1.5', !active);
          dot.classList.toggle('sm:w-2.5', !active);
          dot.classList.toggle('bg-white/40', !active);
          dot.classList.toggle('hover:bg-white/60', !active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
          dot.tabIndex = active ? 0 : -1;
        });

        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
      }

      function scrollToIndex(i, behavior) {
        var target = slides[Math.max(0, Math.min(slides.length - 1, i))];
        if (target) track.scrollTo({ left: target.offsetLeft, behavior: behavior || 'smooth' });
      }

      function step(delta) {
        scrollToIndex(index + delta);
      }

      track.addEventListener(
        'scroll',
        function () {
          var width = track.clientWidth || 1;
          setIndex(Math.round(track.scrollLeft / width));
        },
        { passive: true }
      );

      dots.forEach(function (dot, d) {
        dot.addEventListener('click', function () {
          scrollToIndex(d);
        });
      });

      if (prev) {
        prev.addEventListener('click', function () {
          step(-1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          step(1);
        });
      }

      setIndex(0);
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-hero-slider]'), initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inline-product-sliders"]) return;
  try {
    
  (function () {
    function init() {
      var config = document.querySelector('[data-inline-product-sliders]');
      if (!config) return;

      var apiBase = config.getAttribute('data-api-base');
      var labelBestseller = config.getAttribute('data-label-bestseller') || 'Bestseller';
      var labelNew = config.getAttribute('data-label-new') || 'Neu';
      var labelUnique = config.getAttribute('data-label-unique') || 'Unikat';
      if (!apiBase) return;

      var markers = document.querySelectorAll('[data-mgl-product-slider]:not([data-hydrated])');
      if (!markers.length) return;

      var locale = document.documentElement.lang || 'de';
      var currency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

      function formatMoney(amount) {
        var value = Number(amount) || 0;
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(value);
        } catch (e) {
          return value + ' ' + currency;
        }
      }

      function withWidth(url, width) {
        if (!url) return url;
        return url.indexOf('?') !== -1 ? url + '&width=' + width : url + '?width=' + width;
      }

      function escapeHtml(str) {
        return String(str == null ? '' : str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function splitTitle(rawTitle) {
        var normalized = String(rawTitle || '')
          .replace(/ – /g, ' - ')
          .replace(/ — /g, ' - ');
        var parts = normalized.split(' - ');
        var base = parts.length > 1 ? parts.slice(0, parts.length - 1).join(' - ') : normalized;
        base = base.trim();

        var words = base.split(' ');
        var line1 = '';
        var line2 = '';
        var foundNumber = false;
        var foundCm = false;
        for (var k = 0; k < words.length; k++) {
          var word = words[k];
          if (foundCm) break;
          if (foundNumber) {
            line2 += word + ' ';
            if (word === 'cm') foundCm = true;
          } else {
            var n = parseInt(word, 10);
            if ((!isNaN(n) && n !== 0) || word === '0') {
              foundNumber = true;
              line2 += word + ' ';
            } else {
              line1 += word + ' ';
            }
          }
        }
        return { line1: line1.trim(), line2: line2.trim() };
      }

      function cardHtml(p) {
        var title = escapeHtml(p.title);
        var url = escapeHtml(p.url);
        var tags = p.tags || [];

        var onSale = p.compareAtPrice && Number(p.compareAtPrice) > Number(p.price);
        var discount = Number(p.discountPercentage) || 0;
        if (!discount && onSale) {
          discount = Math.round(
            ((Number(p.compareAtPrice) - Number(p.price)) / Number(p.compareAtPrice)) * 100
          );
        }
        var isOnSale = onSale || discount > 0;

        function hasTag(name) {
          for (var i = 0; i < tags.length; i++) {
            if (String(tags[i]).toLowerCase() === name) return true;
          }
          return false;
        }

        var badges = '';
        if (isOnSale && discount > 0) {
          badges += '<span class="product-badge bg-primary! text-white">-' + discount + '%</span>';
        }
        if (hasTag('bestseller')) {
          badges += '<span class="product-badge">' + escapeHtml(labelBestseller) + '</span>';
        }
        if (hasTag('neu')) {
          badges += '<span class="product-badge">' + escapeHtml(labelNew) + '</span>';
        }
        if (hasTag('unikat')) {
          badges += '<span class="product-badge">' + escapeHtml(labelUnique) + '</span>';
        }

        var hasHover = !!p.roomImageUrl;
        var primaryImg = p.imageUrl
          ? '<img src="' +
            escapeHtml(withWidth(p.imageUrl, 400)) +
            '" alt="' +
            title +
            '" class="aspect-4/5 h-full w-full bg-white object-contain transition-all duration-300 ease-in-out ' +
            (hasHover ? 'group-hover:opacity-0' : 'group-hover:scale-90') +
            '" loading="lazy" decoding="async" width="400" height="500">'
          : '<div class="bg-muted h-full w-full"></div>';

        // Decorative: covers the whole box, so it must not repeat the title.
        var hoverImg = hasHover
          ? '<img src="' +
            escapeHtml(withWidth(p.roomImageUrl, 600)) +
            '" alt="" aria-hidden="true" class="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100" loading="lazy" decoding="async" width="600" height="750">'
          : '';

        var t = splitTitle(p.title);
        var titleHtml =
          '<span class="font-medium">' +
          escapeHtml(t.line1) +
          '</span>' +
          (t.line2 ? '<br><span class="font-light">' + escapeHtml(t.line2) + '</span>' : '');

        var priceHtml =
          '<span class="text-base ' +
          (isOnSale ? 'text-primary font-semibold' : 'font-medium') +
          '">' +
          escapeHtml(formatMoney(p.price)) +
          '</span>';
        if (onSale) {
          priceHtml +=
            '<span class="text-foreground/70 text-sm line-through">' +
            escapeHtml(formatMoney(p.compareAtPrice)) +
            '</span>';
        }

        return (
          '<div data-carousel-item class="w-[60%] shrink-0 sm:w-[40%] md:w-[32%] lg:w-[25%]" role="listitem">' +
          '<div class="group relative flex h-full flex-col space-y-2">' +
          '<div class="absolute top-0 right-0 left-0 z-10 flex flex-wrap items-start gap-1.5">' +
          badges +
          '</div>' +
          '<a href="' +
          url +
          '" class="block" aria-label="' +
          title +
          '">' +
          '<div class="product-image relative aspect-4/5 overflow-hidden bg-white">' +
          primaryImg +
          hoverImg +
          '</div></a>' +
          '<div class="my-2 flex flex-1 flex-col justify-between space-y-0.5">' +
          '<a href="' +
          url +
          '" class="text-foreground hover:text-primary inline-block w-full text-center text-sm leading-snug text-wrap">' +
          titleHtml +
          '</a>' +
          '<div class="flex flex-wrap items-center justify-center gap-1.5">' +
          priceHtml +
          '</div></div></div></div>'
        );
      }

      var CHEVRON_LEFT =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>';
      var CHEVRON_RIGHT =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';

      function sliderHtml(title, products) {
        var items = products.map(cardHtml).join('');
        var heading = title
          ? '<h3 class="font-heading font-medium text-xl md:text-2xl">' +
            escapeHtml(title) +
            '</h3>'
          : '';
        return (
          heading +
          '<div class="relative">' +
          '<base-carousel>' +
          '<div data-carousel-wrapper class="no-scrollbar relative mt-5 flex items-stretch gap-5 overflow-x-auto" role="list">' +
          items +
          '</div>' +
          '<button data-carousel-prev type="button" class="border-border focus-visible:ring-foreground absolute top-2/5 -left-3 grid h-10 w-10 -translate-y-1/2 place-content-center rounded-full border bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50 [&>svg]:size-6" aria-label="Previous product">' +
          CHEVRON_LEFT +
          '</button>' +
          '<button data-carousel-next type="button" class="border-border focus-visible:ring-foreground absolute top-2/5 -right-3 grid h-10 w-10 -translate-y-1/2 place-content-center rounded-full border bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50 [&>svg]:size-6" aria-label="Next product">' +
          CHEVRON_RIGHT +
          '</button>' +
          '</base-carousel></div>'
        );
      }

      function hydrate(marker) {
        marker.setAttribute('data-hydrated', '');
        var ids = (marker.getAttribute('data-product-ids') || '')
          .split(',')
          .map(function (s) {
            return s.trim();
          })
          .filter(Boolean);
        if (!ids.length) {
          marker.style.display = 'none';
          return;
        }
        var title = marker.getAttribute('data-title') || '';

        var url =
          apiBase +
          '/public/storefront/products/by-ids?ids=' +
          encodeURIComponent(ids.join(',')) +
          '&locale=' +
          encodeURIComponent(locale) +
          '&currency=' +
          encodeURIComponent(currency);

        fetch(url)
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
          })
          .then(function (data) {
            var products = (data && data.products) || [];
            if (!products.length) {
              marker.style.display = 'none';
              return;
            }
            marker.classList.add('my-10', 'block', 'not-prose');
            marker.innerHTML = sliderHtml(title, products);
          })
          .catch(function () {
            marker.style.display = 'none';
          });
      }

      for (var i = 0; i < markers.length; i++) hydrate(markers[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection === null) {
      return;
    }

    var productId = productRecommendationsSection.dataset.productId;
    var baseUrl = productRecommendationsSection.dataset.baseUrl;
    var limit = productRecommendationsSection.dataset.limit;

    var requestUrl =
      baseUrl +
      '?section_id=section-product-recommendations&product_id=' +
      productId +
      '&limit=' +
      limit;

    fetch(requestUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var container = document.createElement('div');
        container.innerHTML = html;
        var content = container.querySelector('.product-recommendations');
        if (content) {
          productRecommendationsSection.innerHTML = content.innerHTML;
        }
      });
  };

  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'product-recommendations') {
      loadProductRecommendationsIntoSection();
    }
  });

  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-sliders"]) return;
  try {
    
  (function () {
    function init() {
      var section = document.querySelector('[data-product-sliders]');
      if (!section) return;

      var productId = section.getAttribute('data-product-id');
      var apiBase = section.getAttribute('data-api-base');
      var labelBestseller = section.getAttribute('data-label-bestseller') || 'Bestseller';
      var labelNew = section.getAttribute('data-label-new') || 'Neu';
      var labelUnique = section.getAttribute('data-label-unique') || 'Unikat';
      var mount = section.querySelector('[data-product-sliders-mount]');
      if (!productId || !apiBase || !mount) return;

      var locale = document.documentElement.lang || 'de';
      var currency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

      function formatMoney(amount) {
        var value = Number(amount) || 0;
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(value);
        } catch (e) {
          return value + ' ' + currency;
        }
      }

      function withWidth(url, width) {
        if (!url) return url;
        return url.indexOf('?') !== -1 ? url + '&width=' + width : url + '?width=' + width;
      }

      function escapeHtml(str) {
        return String(str == null ? '' : str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function splitTitle(rawTitle) {
        var normalized = String(rawTitle || '')
          .replace(/ – /g, ' - ')
          .replace(/ — /g, ' - ');
        var parts = normalized.split(' - ');
        var base = parts.length > 1 ? parts.slice(0, parts.length - 1).join(' - ') : normalized;
        base = base.trim();

        var words = base.split(' ');
        var line1 = '';
        var line2 = '';
        var foundNumber = false;
        var foundCm = false;
        for (var k = 0; k < words.length; k++) {
          var word = words[k];
          if (foundCm) break;
          if (foundNumber) {
            line2 += word + ' ';
            if (word === 'cm') foundCm = true;
          } else {
            var n = parseInt(word, 10);
            if ((!isNaN(n) && n !== 0) || word === '0') {
              foundNumber = true;
              line2 += word + ' ';
            } else {
              line1 += word + ' ';
            }
          }
        }
        return { line1: line1.trim(), line2: line2.trim() };
      }

      function cardHtml(p) {
        var title = escapeHtml(p.title);
        var url = escapeHtml(p.url);
        var tags = p.tags || [];

        var onSale = p.compareAtPrice && Number(p.compareAtPrice) > Number(p.price);
        var discount = Number(p.discountPercentage) || 0;
        if (!discount && onSale) {
          discount = Math.round(
            ((Number(p.compareAtPrice) - Number(p.price)) / Number(p.compareAtPrice)) * 100
          );
        }
        var isOnSale = onSale || discount > 0;

        function hasTag(name) {
          for (var i = 0; i < tags.length; i++) {
            if (String(tags[i]).toLowerCase() === name) return true;
          }
          return false;
        }

        var badges = '';
        if (isOnSale && discount > 0) {
          badges += '<span class="product-badge bg-primary! text-white">-' + discount + '%</span>';
        }
        if (hasTag('bestseller')) {
          badges += '<span class="product-badge">' + escapeHtml(labelBestseller) + '</span>';
        }
        if (hasTag('neu')) {
          badges += '<span class="product-badge">' + escapeHtml(labelNew) + '</span>';
        }
        if (hasTag('unikat')) {
          badges += '<span class="product-badge">' + escapeHtml(labelUnique) + '</span>';
        }

        var hasHover = !!p.roomImageUrl;
        var primaryImg = p.imageUrl
          ? '<img src="' +
            escapeHtml(withWidth(p.imageUrl, 400)) +
            '" alt="' +
            title +
            '" class="aspect-4/5 h-full w-full bg-white object-contain transition-all duration-300 ease-in-out ' +
            (hasHover ? 'group-hover:opacity-0' : 'group-hover:scale-90') +
            '" loading="lazy" decoding="async" width="400" height="500">'
          : '<div class="bg-muted h-full w-full"></div>';

        // Decorative: covers the whole box, so it must not repeat the title.
        var hoverImg = hasHover
          ? '<img src="' +
            escapeHtml(withWidth(p.roomImageUrl, 600)) +
            '" alt="" aria-hidden="true" class="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100" loading="lazy" decoding="async" width="600" height="750">'
          : '';

        var t = splitTitle(p.title);
        var titleHtml =
          '<span class="font-medium">' +
          escapeHtml(t.line1) +
          '</span>' +
          (t.line2 ? '<br><span class="font-light">' + escapeHtml(t.line2) + '</span>' : '');

        var priceHtml =
          '<span class="text-base ' +
          (isOnSale ? 'text-primary font-semibold' : 'font-medium') +
          '">' +
          escapeHtml(formatMoney(p.price)) +
          '</span>';
        if (onSale) {
          priceHtml +=
            '<span class="text-foreground/70 text-sm line-through">' +
            escapeHtml(formatMoney(p.compareAtPrice)) +
            '</span>';
        }

        return (
          '<div data-carousel-item class="w-[60%] shrink-0 sm:w-[40%] md:w-[32%] lg:w-[25%]" role="listitem">' +
          '<div class="group relative flex h-full flex-col space-y-2">' +
          '<div class="absolute top-0 right-0 left-0 z-10 flex flex-wrap items-start gap-1.5">' +
          badges +
          '</div>' +
          '<a href="' +
          url +
          '" class="block" aria-label="' +
          title +
          '">' +
          '<div class="product-image relative aspect-4/5 overflow-hidden bg-white">' +
          primaryImg +
          hoverImg +
          '</div></a>' +
          '<div class="my-2 flex flex-1 flex-col justify-between space-y-0.5">' +
          '<a href="' +
          url +
          '" class="text-foreground hover:text-primary inline-block w-full text-center text-sm leading-snug text-wrap">' +
          titleHtml +
          '</a>' +
          '<div class="flex flex-wrap items-center justify-center gap-1.5">' +
          priceHtml +
          '</div></div></div></div>'
        );
      }

      var CHEVRON_LEFT =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>';
      var CHEVRON_RIGHT =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';

      function sliderHtml(slider) {
        var items = (slider.products || []).map(cardHtml).join('');
        return (
          '<div data-product-slider>' +
          '<h3 class="font-heading font-medium text-xl md:text-2xl">' +
          escapeHtml(slider.title) +
          '</h3>' +
          '<div class="relative">' +
          '<base-carousel>' +
          '<div data-carousel-wrapper class="no-scrollbar relative mt-5 flex items-stretch gap-5 overflow-x-auto" role="list">' +
          items +
          '</div>' +
          '<button data-carousel-prev type="button" class="border-border focus-visible:ring-foreground absolute top-2/5 -left-3 grid h-10 w-10 -translate-y-1/2 place-content-center rounded-full border bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50 [&>svg]:size-6" aria-label="Previous product">' +
          CHEVRON_LEFT +
          '</button>' +
          '<button data-carousel-next type="button" class="border-border focus-visible:ring-foreground absolute top-2/5 -right-3 grid h-10 w-10 -translate-y-1/2 place-content-center rounded-full border bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50 [&>svg]:size-6" aria-label="Next product">' +
          CHEVRON_RIGHT +
          '</button>' +
          '</base-carousel>' +
          '</div></div>'
        );
      }

      function render(sliders) {
        var html = sliders.map(sliderHtml).join('');
        section.classList.remove('hidden');
        mount.innerHTML = html;
      }

      var url =
        apiBase +
        '/public/storefront/products/' +
        encodeURIComponent(productId) +
        '/sliders?locale=' +
        encodeURIComponent(locale) +
        '&currency=' +
        encodeURIComponent(currency);

      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var sliders = ((data && data.sliders) || []).filter(function (s) {
            return s && s.products && s.products.length;
          });
          if (sliders.length) render(sliders);
        })
        .catch(function () {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
